export default __webpack_public_path__ + "static/sample_print-8371f64e1faaf14fff9e102c27c21190.jpg";